import { BaseDestinationJobFilterHandler } from '../destination-job-filter';

export class PatientIdFilter<
  JobData extends object,
> extends BaseDestinationJobFilterHandler<JobData> {
  key = 'patientId';
  label = 'Patient Id';
  description = 'Source Id for the patient';
}
